export default __webpack_public_path__ + "static/media/notes.926638d2.svg";